import type { IAddFilterMenu } from '../../../../types/data_table';

import { Plus } from '../../../../assets/Icons';

import { Dropdown } from '../../../Dropdown';
import { DropdownButton } from '../../../Dropdown/DropdownButton';
import { DropdownMenu } from '../../../Dropdown/DropdownMenu';
import { DropdownMenuItem } from '../../../Dropdown/DropdownMenuItem';

/**
 * The "+" control listing every text and phone filter that can be applied.
 *
 * Each entry opens its own nested `Dropdown`, so the field is typed into
 * without leaving the list. The whole tree is one component because `Dropdown`
 * and `DropdownMenu` find their children by element type — splitting the list
 * items out would leave them unable to open.
 */
export const AddFilterMenu = ({
  filters,
  disabled,
  renderMenu,
  onApply,
  onClose,
}: IAddFilterMenu) => (
  <Dropdown
    width="fit-content"
    onToggleHandler={(open) => {
      if (open === false) onClose();
    }}
  >
    <DropdownButton
      leadingIcon={Plus}
      hideDropdownChevron
      disabled={disabled}
    />

    <DropdownMenu
      maxHeight="fit-content"
      horizontalPlacement="auto"
      width="fit-content"
    >
      {filters.map((filter, index) => (
        <Dropdown key={`${filter.id}-field-filter-${index}`} focusOnMenuOpen>
          <DropdownButton
            renderAs={
              <DropdownMenuItem
                type="default"
                hideCheckMarks
                text={filter.label}
                closeOnItemClick={false}
              />
            }
          />
          {renderMenu(filter, (value) => onApply(filter, value))}
        </Dropdown>
      ))}
    </DropdownMenu>
  </Dropdown>
);
